import { createIcon } from '@chakra-ui/react'

export const CheckMark = createIcon({
  displayName: 'Check',
  viewBox: '0 0 48 48',
  d: 'M23.9998 0.666016C11.1198 0.666016 0.666504 11.1193 0.666504 23.9994C0.666504 36.8794 11.1198 47.3327 23.9998 47.3327C36.8798 47.3327 47.3332 36.8794 47.3332 23.9994C47.3332 11.1193 36.8798 0.666016 23.9998 0.666016ZM19.3332 35.666L7.6665 23.9994L10.9565 20.7094L19.3332 29.0627L37.0432 11.3527L40.3332 14.666L19.3332 35.666Z',
})
